import {
  IconButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  PopoverVirtualElement,
  Tooltip,
} from '@mui/material';
import {
  IconArrowRight,
  IconCopy,
  IconExternalLink,
  IconWorldShare,
} from '@tabler/icons-react';
import { SxProps } from '@mui/system';
import { Theme, useTheme } from '@mui/material/styles';
import { SyntheticEvent, useState } from 'react';
import { copyClipboard } from 'utils/functions';

type InlineLinkButtonProps = {
  link: string;
  tooltip?: string;
  sx?: SxProps<Theme>;
};

const InlineLinkButton = ({
  link,
  tooltip = '',
  sx,
}: InlineLinkButtonProps) => {
  const theme = useTheme();
  const [anchorEl, setAnchorEl] = useState<
    Element | PopoverVirtualElement | null
  >(null);

  const handleClick = (event: SyntheticEvent) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  return (
    <>
      <Menu
        id="menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        variant="selectedMenu"
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <MenuItem
          onClick={() => {
            window.location.href = link;
          }}
        >
          <ListItemIcon>
            <IconArrowRight />
          </ListItemIcon>
          <ListItemText>Go To Link</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            window.open(link, '_blank');
            handleClose();
          }}
        >
          <ListItemIcon>
            <IconExternalLink />
          </ListItemIcon>
          <ListItemText>Open Link In New Tab</ListItemText>
        </MenuItem>
        <MenuItem
          onClick={() => {
            copyClipboard(link);
            handleClose();
          }}
        >
          <ListItemIcon>
            <IconCopy />
          </ListItemIcon>
          <ListItemText>Copy Link</ListItemText>
        </MenuItem>
      </Menu>
      <Tooltip title={tooltip} sx={{ ...sx }}>
        <IconButton
          onMouseDown={(event) => event.stopPropagation()}
          onTouchStart={(event) => event.stopPropagation()}
          onClick={(event) => {
            event.stopPropagation();
            event.preventDefault();
            handleClick(event);
          }}
          size="small"
        >
          <IconWorldShare
            width={20}
            height={20}
            color={theme.palette.primary.main}
          />
        </IconButton>
      </Tooltip>
    </>
  );
};

export default InlineLinkButton;
